// Centralized fetch wrapper that handles 401 Unauthorized and redirects to login
export async function fetchWithAuth(input: RequestInfo, init?: RequestInit): Promise<Response> {
  const res = await fetch(input, {
    ...init,
    credentials: 'include',
  });
  if (res.status === 401) {
    window.location.href = '/login';
    // Optionally, throw to stop further processing
    throw new Error('Unauthorized: Redirecting to login');
  }
  return res;
}
